import { put } from '@rails/request.js';

import {
  clearCsrfReloadMarker,
  isCsrfRejection,
  reloadOnceForCsrfRejection,
} from '../_utils/csrf-recovery';
import { observableEvent } from '../_utils/observable-event';

async function updateStoreOnServer({ url, ...params }) {
  const formData = buildFormData(params);

  const response = await put(url, {
    body: formData,
    responseKind: 'json',
  });

  handleResponse(response);

  // A plain shape, so callers do not depend on FetchResponse's API.
  return { ok: response.ok, status: response.statusCode };
}

function buildFormData(params) {
  const formData = new FormData();
  const permittedParams = [
    'size',
    'finish',
    'prism_id',
    'soft',
    'item',
    'quantity',
    'option',
  ];

  Object.entries(params).forEach(([key, value]) => {
    if (permittedParams.includes(key)) {
      if (key === 'quantity') {
        formData.append('values[copies]', value);
      } else {
        formData.append(key, value);
      }
    }
  });

  return formData;
}

function handleResponse(response) {
  if (response.ok) {
    clearCsrfReloadMarker();
    return;
  }

  observableEvent.record('grouped-page-action-fail', {
    status: response.statusCode,
    url: response.response.url.replace(window.location.origin, ''),
  });

  if (isCsrfRejection(response)) {
    reloadOnceForCsrfRejection();
  }
}



export { updateStoreOnServer };
